export const tools = [
  'paper',
  'word',
  'edumoov',
  'goodnotes',
  'planner',
  'other',
] as const;

export type ToolType = (typeof tools)[number];
